import React from 'react';

import TableHeaderComponent from './table-header.component.jsx';

const TableHeader = (props) => {
    return <TableHeaderComponent {...props} />;
};

export default TableHeader;
